//GET_ALL_TRADE_LICENSE
export const GET_ALL_TRADE_LICENSE_REQUEST = "GET_ALL_TRADE_LICENSE_REQUEST";
export const GET_ALL_TRADE_LICENSE_SUCCESS = "GET_ALL_TRADE_LICENSE_SUCCESS";
export const GET_ALL_TRADE_LICENSE_FAIL = "GET_ALL_TRADE_LICENSE_FAIL";

//UPDATE_TRADE_LICENSE
export const UPDATE_TRADE_LICENSE_REQUEST = "UPDATE_TRADE_LICENSE_REQUEST";
export const UPDATE_TRADE_LICENSE_SUCCESS = "UPDATE_TRADE_LICENSE_SUCCESS";
export const UPDATE_TRADE_LICENSE_FAIL = "UPDATE_TRADE_LICENSE_FAIL";

//ARCHIVE_TRADE_LICENSE
export const ARCHIVE_TRADE_LICENSE_REQUEST = "ARCHIVE_TRADE_LICENSE_REQUEST";
export const ARCHIVE_TRADE_LICENSE_SUCCESS = "ARCHIVE_TRADE_LICENSE_SUCCESS";
export const ARCHIVE_TRADE_LICENSE_FAIL = "ARCHIVE_TRADE_LICENSE_FAIL";

//CREATE_TRADE_LICENSE
export const CREATE_TRADE_LICENSE_REQUEST = "CREATE_TRADE_LICENSE_REQUEST";
export const CREATE_TRADE_LICENSE_SUCCESS = "CREATE_TRADE_LICENSE_SUCCESS";
export const CREATE_TRADE_LICENSE_FAIL = "CREATE_TRADE_LICENSE_FAIL";

//DELETE_EXPIRED_TRADE_LICENSE
export const DELETE_EXPIRED_TRADE_LICENSE_REQUEST =
  "DELETE_EXPIRED_TRADE_LICENSE_REQUEST";
export const DELETE_EXPIRED_TRADE_LICENSE_SUCCESS =
  "DELETE_EXPIRED_TRADE_LICENSE_SUCCESS";
export const DELETE_EXPIRED_TRADE_LICENSE_FAIL =
  "DELETE_EXPIRED_TRADE_LICENSE_FAIL";

//  BULK_ASSIGN_TRADE_LICENSE
export const BULK_ASSIGN_TRADE_LICENSE_REQUEST =
  "BULK_ASSIGN_TRADE_LICENSE_REQUEST";
export const BULK_ASSIGN_TRADE_LICENSE_SUCCESS =
  "BULK_ASSIGN_TRADE_LICENSE_SUCCESS";
export const BULK_ASSIGN_TRADE_LICENSE_FAIL = "BULK_ASSIGN_TRADE_LICENSE_FAIL";

//DELETE_TRADE_LICENSE
export const DELETE_TRADE_LICENSE_REQUEST = "DELETE_TRADE_LICENSE_REQUEST";
export const DELETE_TRADE_LICENSE_SUCCESS = "DELETE_TRADE_LICENSE_SUCCESS";
export const DELETE_TRADE_LICENSE_FAIL = "DELETE_TRADE_LICENSE_FAIL";
